<template>
  <div v-touch:swipe="swipeRow" v-touch:tap="tabRow" @mouseover="overList" @mouseout="outList" :class="(controls && totalRows > show && !hasTouch)? 'container-fluid tinkList' : 'container-fluid tinkListNoControl'" :id="'tinkList_' + _uid">

    <div v-if="showMessage" :id="'tinkListMessage_' + _uid" :class="(messageClass)? `tinkListMessage ${messageClass}` : `tinkListMessage`"></div>

    <!--div class="tinkListMessage" style="visibility: visible">
      {{ this.lastOfRow }} /
      {{ this.heightOfRow }} /
    </div-->

    <div v-if="controls && controlPrev && totalRows > show" :class="(controlPrevClass)? `tinkListPrevControl ${controlPrevClass}` : `tinkListPrevControl`" :id="'tinkListPrevControl_' + _uid" @click="previousRow">
      <slot name="controlPrev">
        <b-button size="sm" class="p-0 pl-1 pr-1">&lt;</b-button>
      </slot>
    </div>

    <div v-if="controls && controlNext && totalRows > show" :class="(controlNextClass)? `tinkListNextControl ${controlNextClass}` : `tinkListNextControl`" :id="'tinkListNextControl_' + _uid"  @click="nextRow">
      <slot name="controlNext">
        <b-button size="sm" class="p-0 pl-1 pr-1">&gt;</b-button>
      </slot>
    </div>

    <div :class="(rowClass)? `row tinkListRow ${rowClass} `:'row tinkListRow'" :id="'tinkListRow_' + _uid">
      <slot></slot>
    </div>
  </div>
</template>
<script>

  import uiUtil from "@/mixins/util.js"

  export const tinkList = {
    name: "tinkList",
    mixins: [uiUtil],
    props: {
      "lastLinePrevWidth": {
        type: Boolean,
        default: false
      },
      "start": {
        type: Number,
        default: 0
      },
      "show": {
        type: Number,
        default: 1
      },
      "autoRotate": {
        type: Number,
        default: 0
      },
      "swipeDisabled" : {
        type: Boolean,
        default: false,
      },
      "swipeLeftDisabled" : {
        type: Boolean,
        default: false,
      },
      "swipeRightDisabled" : {
        type: Boolean,
        default: false,
      },
      "tabDisabled" : {
        type: Boolean,
        default: false,
      },
      "controls": {
        type: Boolean,
        default: true
      },
      "controlPrev": {
        type: Boolean,
        default: true
      },
      "controlNext": {
        type: Boolean,
        default: true
      },
      "controlsPosition": {
        type: String,
        default: "middle"
      },
      "showMessage": {
        type: Boolean,
        default: true
      },
      "controlPrevClass": String,
      "controlNextClass": String,
      "controlsHeight": {
        type: Number,
        default: -1
      },
      "rowClass": String,
      "messageClass": String,
    },
    data: function() {
      return {
        itemsLength: 0,
        pauseRotate: false,
        drawOnce: false,
        totalRows: 0,
        currentRow: 0,
        rotateTimer: null,
        // lastOfRow: [],
        // heightOfRow: [],
      }
    },
    created() {
      this.currentRow = this.start;
      window.addEventListener("resize", this.redraw);
    },
    mounted() {
      this.$log.debug("tinkList mounted", this.controlPrevClass, this.controlNextClass, this.controlsPosition, this.show);
      this.redraw();
      if(this.autoRotate >= 3000) {
        this.rotateTimer = window.setInterval(() => {
          this.autoNextRow();
        }, this.autoRotate);
      }
    },
    updated() {
      this.$log.debug("tinkList updated");
      let rowEl = window.document.getElementById("tinkListRow_" + this._uid);
      if(rowEl) {
        if(this.itemsLength != rowEl.children.length) {
          this.redraw();
        }
      }
    },
    destroyed() {
      this.$log.debug("tinkList destroyed");
      window.removeEventListener("resize", this.redraw);
    },
    methods: {
      outList: function() {
        this.pauseRotate = false;
      },
      overList: function() {
        this.pauseRotate = true;
      },
      autoNextRow: function() {
        if(!this.pauseRotate) {
          this.nextRow();
        }
      },
      tabRow: function(evt) {
        if(!evt || evt.srcElement.tagName.toLowerCase() != "button") {
          this.nextRow(evt);
          if(this.autoRotate >= 3000 && this.rotateTimer != 0 && !this.tabDisabled) {
            window.clearInterval(this.rotateTimer);
            this.rotateTimer = window.setInterval(() => {
              this.autoNextRow();
            }, this.autoRotate);
          }
        }
      },
      swipeRow: function(direction) {
        if(direction == "left" && !this.swipeLeftDisabled && !this.swipeDisabled) {
          this.previousRow();
        }
        else if(direction == "right" && !this.swipeLeftDisabled && !this.swipeDisabled) {
          this.nextRow();
        }
      },
      nextRow: function(evt) {
        this.$log.debug(this.currentRow, this.totalRows, this.show)
        if(this.show != -1) {
          if(this.currentRow >= (this.totalRows - this.show)) {
            this.currentRow = 0;
          }
          else {
            this.currentRow = this.currentRow + this.show;
          }
          this.redraw();
        }
        if(evt) evt.stopPropagation();
      },
      previousRow: function(evt) {
        if(this.show != -1) {
          if(this.currentRow == 0) {
            this.currentRow = this.totalRows - this.show;
          }
          else if((this.currentRow-this.show) < 0) {
            this.currentRow = 0;
          }
          else {
            this.currentRow = this.currentRow - this.show;
          }
          if(this.currentRow < 0) this.currentRow = 0;
          this.redraw();
        }
        if(evt) evt.stopPropagation();
      },

      resetHeight: function() {
        let boxEl = window.document.getElementById("tinkList_" + this._uid);
        let rowEl = window.document.getElementById("tinkListRow_" + this._uid);
        if(!rowEl) return;

        let boxElWidth = this.width(boxEl);
        let tempWidth = 0;
        let tempHeight = 0;
        let heightOfRow = [];

        for(let i=0;i<rowEl.children.length;i++) {

          tempWidth += this.outerWidth(rowEl.children[i]);

          if(Math.floor(tempWidth) > Math.ceil(boxElWidth)) {
            heightOfRow.push(tempHeight);
            tempWidth = this.outerWidth(rowEl.children[i]);
            tempHeight = this.outerHeight(rowEl.children[i]);
          }
          else {
            if(this.outerHeight(rowEl.children[i])>tempHeight) {
              tempHeight = this.outerHeight(rowEl.children[i]);
            }
          }
          if(i == (rowEl.children.length-1)) {
            heightOfRow.push(tempHeight);
          }
        }

        if(this.totalRows != 0) {
          let startRow=0, endRow=0;
          if(this.show == -1) {
            endRow = this.totalRows - 1;
          }
          else {
            if(this.currentRow < this.totalRows) {
              if((this.currentRow + this.show - 1) >= this.totalRows) {
                startRow = this.totalRows - this.show;
                endRow = this.totalRows - 1;
              }
              else {
                startRow = this.currentRow;
                endRow = this.currentRow + this.show - 1;
              }
            }
            else {
              startRow = this.totalRows - this.show;
              endRow = this.totalRows - 1;
            }
          }
          if(startRow < 0) {
            startRow = 0;
          }
          if(endRow > this.totalRows) {
            endRow = this.totalRows - 1;
          }
          let offsetTop = this.offsetTop(rowEl);
          let scrollHeight = 0;
          let showHeight = 0;
          let lastMarginBottom = 0;
          for(let i=0;i<=endRow;i++) {
            if(i>=startRow) {
              showHeight += heightOfRow[i];
            }
            else {
              scrollHeight += heightOfRow[i];
            }
            if(i==endRow) {
              lastMarginBottom = this.marginBottom(rowEl.children[i]);
            }
          }
          boxEl.style.height = (showHeight + offsetTop + lastMarginBottom) + "px";
          if(this.show != -1 && this.controls && (this.controlPrev || this.controlNext) && this.totalRows > 1) {
            window.setTimeout(() => {
              try {
                let controlPrevEl = (this.controlPrev)? window.document.getElementById("tinkListPrevControl_" + this._uid): null;
                let controlNextEl = (this.controlNext)? window.document.getElementById("tinkListNextControl_" + this._uid): null;
                if(this.controlsPosition != "custom" && this.controlsHeight >= 0) {
                  if(this.controlPrev) {
                    controlPrevEl.style.height = (showHeight - this.marginTop(controlPrevEl) - this.marginTop(controlPrevEl) - lastMarginBottom)*this.controlsHeight + "px";
                  }
                  if(this.controlNext) {
                    controlNextEl.style.height = (showHeight - this.marginTop(controlNextEl) - this.marginTop(controlNextEl) - lastMarginBottom)*this.controlsHeight + "px";
                  }
                }
                if(this.controlsPosition == "middle") {
                  if(this.controlPrev) {
                    if(this.controlsHeight >=0 ) {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - showHeight*this.controlsHeight/2 - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                    else {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - this.height(controlPrevEl)/2 - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                  }
                  if(this.controlNext) {
                    if(this.controlsHeight >= 0) {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - showHeight*this.controlsHeight/2 - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                    else {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - this.height(controlNextEl)/2 - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                  }
                }
                else if(this.controlsPosition == "bottom") {
                  if(this.controlPrev) {
                    if(this.controlsHeight >=0 ) {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - showHeight*this.controlsHeight - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                    else {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - this.height(controlPrevEl) - this.paddingTop(controlPrevEl) - this.paddingBottom(controlPrevEl) - lastMarginBottom) + "px";
                    }
                  }
                  if(this.controlNext) {
                    if(this.controlsHeight >=0 ) {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - showHeight*this.controlsHeight  - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                    else {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - this.height(controlNextEl) - this.paddingTop(controlNextEl) - this.paddingBottom(controlNextEl) - lastMarginBottom) + "px";
                    }
                  }
                }
                else if(this.controlsPosition == "top") {
                  if(this.controlPrev) {
                    controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl)) + "px";
                  }
                  if(this.controlNext) {
                    controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl)) + "px";
                  }
                }
                if(this.controlPrev) {
                  controlPrevEl.style.visibility = "visible";
                }
                if(this.controlNext) {
                  controlNextEl.style.visibility = "visible";
                }
              }
              catch(error) {
              }
            }, 50);
          }
          if(this.totalRows > 1 && this.show != -1) {
            boxEl.scroll(0,scrollHeight);
          }
        }
        else {
          boxEl.style.height = "0px";
        }
      },


      redraw: function() {
        let boxEl = window.document.getElementById("tinkList_" + this._uid);
        let rowEl = window.document.getElementById("tinkListRow_" + this._uid);
        if(!rowEl) return;

        this.itemsLength = rowEl.children.length;

        // 각 줄에 들어가는 항목 수, 각 줄별 최대 높이를 계산하여 저장함
        let boxElWidth = this.width(boxEl);
        let tempWidth = 0;
        let tempHeight = 0;
        let lastOfRow = [];
        let heightOfRow = [];

        for(let i=0;i<rowEl.children.length;i++) {

          this.$log.debug(this.height(rowEl.children[i]), this.innerHeight(rowEl.children[i]), this.outerHeight(rowEl.children[i]));

          tempWidth += this.outerWidth(rowEl.children[i]);
          this.$log.debug("i", i, "width sum", tempWidth, "boxElWidth", boxElWidth);

          if(Math.floor(tempWidth) > Math.ceil(boxElWidth)) {
            lastOfRow.push(i-1);
            heightOfRow.push(tempHeight);
            tempWidth = this.outerWidth(rowEl.children[i]);
            tempHeight = this.outerHeight(rowEl.children[i]);
            this.$log.debug("i", i, "width init", tempWidth);
          }
          else {
            if(this.outerHeight(rowEl.children[i])>tempHeight) {
              tempHeight = this.outerHeight(rowEl.children[i]);
            }
          }
          if(i == (rowEl.children.length-1)) {
            lastOfRow.push(i);
            heightOfRow.push(tempHeight);
          }
        }

        if(this.lastLinePrevWidth) {
          if(lastOfRow.length > 1) {
            for(let i=Math.floor(rowEl.children.length/(lastOfRow[0] + 1))*(lastOfRow[0] + 1);i<rowEl.children.length;i++) {
              rowEl.children[i].style.maxWidth = this.width(rowEl.children[i-(lastOfRow[0] + 1)]) + "px";
            }
          }
        }

        // this.$set(this, "lastOfRow", lastOfRow);
        // this.$set(this, "heightOfRow", heightOfRow);

        this.$log.debug("lastOfRow", lastOfRow);
        this.$log.debug("heightOfRow", heightOfRow);

        this.totalRows = lastOfRow.length;

        if(this.totalRows > 1) {
          // 시작과 끝 row를 결정함
          let startRow=0, endRow=0;
          if(this.show == -1) {
            endRow = this.totalRows - 1;
          }
          else {
            if(this.currentRow < this.totalRows) {
              if((this.currentRow + this.show - 1) >= this.totalRows) {
                startRow = this.totalRows - this.show;
                endRow = this.totalRows - 1;
              }
              else {
                startRow = this.currentRow;
                endRow = this.currentRow + this.show - 1;
              }
            }
            else {
              startRow = this.totalRows - this.show;
              endRow = this.totalRows - 1;
            }
          }
          if(startRow < 0) {
            startRow = 0;
          }

          if(endRow > this.totalRows) {
            endRow = this.totalRows - 1;
          }

          this.$log.debug("totalRows", this.totalRows, "currentRow:", this.currentRow, "startRow:", startRow, "endRow:", endRow, "show", this.show);

          let offsetTop = this.offsetTop(rowEl);

          let scrollHeight = 0;
          let showHeight = 0;
          let lastMarginBottom = 0;

          for(let i=0;i<=endRow;i++) {
            if(i>=startRow) {
              showHeight += heightOfRow[i];
            }
            else {
              scrollHeight += heightOfRow[i];
            }
            if(i==endRow) {
              try {
                lastMarginBottom = this.marginBottom(rowEl.children[i]);
              }
              catch(error) {
                lastMarginBottom = 0;
              }
            }
          }

          boxEl.style.height = (showHeight + offsetTop + lastMarginBottom) + "px";

          this.$log.debug(showHeight, offsetTop, lastMarginBottom);

          this.$log.debug("showHeight", showHeight);
          // this.$log.debug("lastOfRow", this.lastOfRow);
          // this.$log.debug("heightOfRow", this.heightOfRow);

          // 이전, 다음 높이, 위치를 잡음.

          if(this.show != -1 && this.controls && (this.controlPrev || this.controlNext)) {
            window.setTimeout(() => {
              try {

                let controlPrevEl = (this.controlPrev)? window.document.getElementById("tinkListPrevControl_" + this._uid): null;

                let controlNextEl = (this.controlNext)? window.document.getElementById("tinkListNextControl_" + this._uid): null;


                if(this.controlsPosition != "custom" && this.controlsHeight >= 0) {
                  if(this.controlPrev) {
                    controlPrevEl.style.height = (showHeight - this.marginTop(controlPrevEl) - this.marginTop(controlPrevEl) - lastMarginBottom)*this.controlsHeight + "px";
                  }
                  if(this.controlNext) {
                    controlNextEl.style.height = (showHeight - this.marginTop(controlNextEl) - this.marginTop(controlNextEl) - lastMarginBottom)*this.controlsHeight + "px";
                  }
                }

                if(this.controlsPosition == "middle") {
                  if(this.controlPrev) {
                    if(this.controlsHeight >=0 ) {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - showHeight*this.controlsHeight/2 - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                    else {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - this.height(controlPrevEl)/2 - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                  }

                  if(this.controlNext) {
                    if(this.controlsHeight >= 0) {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - showHeight*this.controlsHeight/2 - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                    else {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight/2 - this.height(controlNextEl)/2 - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                  }
                }

                else if(this.controlsPosition == "bottom") {
                  if(this.controlPrev) {
                    if(this.controlsHeight >=0 ) {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - showHeight*this.controlsHeight - this.borderTopWidth(controlPrevEl) - this.borderBottomWidth(controlPrevEl)) + "px";
                    }
                    else {
                      controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - this.height(controlPrevEl) - this.paddingTop(controlPrevEl) - this.paddingBottom(controlPrevEl) - lastMarginBottom) + "px";
                    }
                  }
                  if(this.controlNext) {
                    if(this.controlsHeight >=0 ) {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - showHeight*this.controlsHeight  - this.borderTopWidth(controlNextEl) - this.borderBottomWidth(controlNextEl)) + "px";
                    }
                    else {
                      controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl) + showHeight - this.height(controlNextEl) - this.paddingTop(controlNextEl) - this.paddingBottom(controlNextEl) - lastMarginBottom) + "px";
                    }
                  }
                }

                else if(this.controlsPosition == "top") {
                  if(this.controlPrev) {
                    controlPrevEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl)) + "px";
                  }
                  if(this.controlNext) {
                    controlNextEl.style.top = (scrollHeight + this.paddingTop(boxEl) + this.offsetTop(rowEl)) + "px";
                  }
                }
                if(this.controlPrev) {
                  controlPrevEl.style.visibility = "visible";
                }
                if(this.controlNext) {
                  controlNextEl.style.visibility = "visible";
                }
              }
              catch(error) {
              }
            }, 50);
          }

          //메시지 상자를 표시하고 감춤
          if(this.show != -1) {
            if(this.showMessage) {
              let messageEl = window.document.getElementById("tinkListMessage_" + this._uid);
              messageEl.innerHTML = (this.show == 1)? (startRow+1) + " / " + this.totalRows : (startRow+1) + "~" + (endRow+1) + " / " + this.totalRows;

              this.$log.debug(scrollHeight, showHeight);

              messageEl.style.top = ( scrollHeight +  parseFloat(window.getComputedStyle(boxEl).getPropertyValue("padding-top")) + showHeight/2 - parseFloat(window.getComputedStyle(messageEl).getPropertyValue("height"))/2) + "px";


              messageEl.style.left = ( parseFloat(window.getComputedStyle(boxEl).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(boxEl).getPropertyValue("width"))/2  - parseFloat(window.getComputedStyle(messageEl).getPropertyValue("width"))/2) + "px";
              messageEl.style.visibility = "visible";

              window.setTimeout(() => {
                messageEl.style.visibility = "hidden";
              }, 2000);

            }
            // 해당 줄까지 스크롤합니다.
            boxEl.scroll(0,scrollHeight);
          }
        }
        else if(this.totalRows == 0) {
          boxEl.style.height = "0px";
        }
        else {
          // totalRows == 1 do Nothing
        }
      }
    }
  }
  export { default as tinkListItem } from './tinkListItem.vue';
  export default tinkList;

</script>
<style>
  .tinkListPrevControl {
    position: absolute;
    left: 0.25rem;
    visibility: hidden;
  }
  .tinkListNextControl {
    position: absolute;
    right: 0.25rem;
    visibility: hidden;
  }
  .tinkListPrevControl button {
    font-size: 0.5rem; opacity : 0.5; height:100%; width:100%;
  }
  .tinkListNextControl button {
    font-size: 0.5rem; opacity : 0.5; height:100%; width:100%;
  }
  .tinkListRow {
    padding: 0px !important;
    margin: 0px !important;
    border-width: 0px !important;
  }
  .tinkListRow > div {
    border-width: 0px !important;
    padding: 0px;
    margin: 0rem 0.5rem 0.5rem 0rem;
  }
  .tinkList {
    position: relative;
    overflow: hidden;
    padding: 0.5rem 1rem 0.5rem 1.5rem;
    z-index: 1000;
  }

  .tinkListNoControl {
    position: relative;
    overflow: hidden;
    padding: 0.5rem 0rem 0.5rem 0.5rem;
    z-index: 1000;
  }

  .tinkListMessage {
    position: absolute;
    visibility: hidden;
    font-size: 0.8rem;
    font-weight: bold;
    color: red;
    padding: 0.2rem 0.8rem 0.2rem 0.8rem;
    background-color: rgba(255,255,255,0.8);
    color: black;
    z-index: 1005;
    text-align:center;
    border-radius: 0.75rem;
  }
</style>
